import { AbstractFormFragment } from '@components/form/AbstractFormFragment';

export class CaptchaFormFragment extends AbstractFormFragment {
  static getCssClassName(): string {
    return 'comp-form-captcha';
  }

  initializeNode(): this {
    this.captchaTimer();
    return this;
  }

  captchaRefresh(name: string): void {
    const key = String(Math.random()).substring(3, 8);
    const imgElem = this.node.querySelector(`#${name}-cq-captchaimg`);
    const keyElem = this.node.querySelector<HTMLInputElement>(`#${name}-cq-captchakey`);
    if (imgElem) {
      const href = imgElem.getAttribute('xlink:href') ?? '';
      imgElem.setAttribute('xlink:href', href.split('?')[0] + '?id=' + key);
    }
    if (keyElem) {
      keyElem.setAttribute('value', key);
    }
  }

  captchaTimer(): void {
    const name = this.node.getAttribute('data-captcha-name') ?? '';
    this.captchaRefresh(name);
  }

  isValid(): boolean {
    const input = this.node.querySelector<HTMLInputElement>('input[type=text]');
    return (input?.value.length ?? 0) > 0;
  }

  attachChangeListener(callback: () => void): this {
    this.node
      .querySelector<HTMLInputElement>('input[type=text]')
      ?.addEventListener('input', () => {
        this.triggerDelayed(callback);
      });
    return this;
  }
}

export default CaptchaFormFragment;
